const PlaceTypes = {
  Unspecified: 0,
  Location: 1,
}

const SizeTypes = {
  ZeroToSeventy: 0,
  SeventyToNinety: 1,
  NinetyToHundredTen: 2,
  HundredTenToHundredFifty: 3,
  MoreThanHundredFifty: 4,
}

const UnitStatus = {
  ForRent: 1,
  Rented: 2,
  RentedWithReservation: 3,
  Reserved: 4,
  New: 5
}

const radiusOptions = [5, 10, 20, 30, 40, 50, 75, 100, 150, 200]

const startRangeOptions = [
  500, 600, 700, 800, 900, 1000, 1100, 1200, 1500, 2000,
]

const endRangeOptions = [600, 700, 800, 900, 1000, 1100, 1200, 1500, 2000, 9999]

export default {
  radiusOptions,
  startRangeOptions,
  endRangeOptions,
  PlaceTypes,
  SizeTypes,
  UnitStatus,
}
